export default __webpack_public_path__ + "static/media/hide.7a0c395d.svg";